module.exports = __webpack_public_path__ + "img/首页插画.58a3dfa7.svg";